

// 메뉴그룹 리스트 조회
import {useEffect} from "react";
import {menuGrpList} from "../service/menuService";
import {getOptionGrpList} from "../service/optionService";

export function useMenuGrpList(setters, shopId) {
  useEffect(() => {
    const response = async () => {
      if(shopId) {
        const data = await menuGrpList(shopId);
        const optionData = await getOptionGrpList(shopId);
        if(data?.length > 0) {
          data.sort(function(a, b) {
            return parseFloat(a.visibleIndex) - parseFloat(b.visibleIndex);
          });

          data.forEach(({menuList}) => {
            menuList.sort(function(a, b) {
              return parseFloat(a.visibleIndex) - parseFloat(b.visibleIndex);
            });
          })
        }

        setters.setList?.(data);
        setters.setOptionList?.(optionData);
      }
    }

    response();
  }, [shopId]);
}